// extracted by mini-css-extract-plugin
export default {"form":"delete-project_form__ztg5x","text":"delete-project_text__94nye","controls":"delete-project_controls__2wThJ"};